import React from 'react';
export function Footer() {
  return <footer className="bg-cream" data-id="element-92" data-mp="32wd0e9mw79qd">
      <div className="mx-auto flex max-w-6xl flex-col items-center gap-4 px-5 py-12 text-center" data-id="element-93" data-mp="32u0ghqxkqpao">
        <p className="font-display text-lg font-bold text-ink" data-id="element-94" data-mp="3gh3ng3oilm9v">+300 Mapas Mentales de Inglés™</p>
        <nav aria-label="Enlaces legales" data-id="element-95" data-mp="32m1c310wf4po">
          <ul className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-sm text-muted" data-id="element-96" data-mp="36qhhl16loa4d">
            <li data-id="element-97" data-mp="3ug3c3bc12161">
              <a href="#politica-reembolso" id="politica-reembolso" className="transition-colors duration-150 ease-out-expo hover:text-coral" data-id="element-98" data-mp="3ufjyu7xbo0yc">
                Política de reembolso
              </a>
            </li>
            <li data-id="element-99" data-mp="3lggaaofdytcg">
              <a href="#terminos" className="transition-colors duration-150 ease-out-expo hover:text-coral" data-id="element-100" data-mp="3qdf4t82yp2b6">
                Términos y condiciones
              </a>
            </li>
            <li data-id="element-101" data-mp="2a19uhoqc1syc">
              <a href="#privacidad" className="transition-colors duration-150 ease-out-expo hover:text-coral" data-id="element-102" data-mp="2eya1c1v0azqi">
                Privacidad
              </a>
            </li>
            <li data-id="element-103" data-mp="3l9sfwwylmeks">
              <a href="#contacto" className="transition-colors duration-150 ease-out-expo hover:text-coral" data-id="element-104" data-mp="3lbdc0r0ka5kr">
                Contacto
              </a>
            </li>
          </ul>
        </nav>
        
      </div>
    </footer>;
}